import * as setup from '@/setup';
import Button from '@/objects/button';
import axios from 'axios';

export default class PendingChallenges extends Phaser.Scene {
	constructor() {
		super({key: 'PendingChallenges'});
		this.challenges = [];
		this.loadingText = null;
	}

	create() {
		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		// Titolo
		this.add.text(
			centerX,
			centerY - 250,
			'Sfide in attesa',
			{...setup.styles.gameOver.greetingStyle, fontSize: 36, fill: '#FFFFFF'}
		).setOrigin(0.5);

		// Testo di caricamento
		this.loadingText = this.add.text(
			centerX,
			centerY,
			'Caricamento sfide...',
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);

		// Bottone indietro
		const backButton = new Button(
			this,
			centerX,
			centerY + 280,
			'red-button',
			1.2,
			'Indietro',
			false
		);

		backButton.on('pointerup', () => {
			this.scene.start('Boot');
		});

		// Carica sfide
		this.loadChallenges();
	}

	loadChallenges() {
		axios.get('/api/invites')
			.then((response) => {
				this.loadingText.destroy();
				this.challenges = response.data;
				
				if (this.challenges.length === 0) {
					this.showNoChallenges();
				} else {
					this.displayChallenges();
				}
			})
			.catch((error) => {
				console.error('Errore caricamento sfide:', error);
				this.loadingText.destroy();
				this.showError('Errore nel caricamento delle sfide');
			});
	}

	displayChallenges() {
		const centerX = this.sys.game.config.width / 2;
		const startY = this.sys.game.config.height / 2 - 150;
		const spacing = 80;

		this.challenges.forEach((challenge, index) => {
			const y = startY + (index * spacing);
			
			// Nome sfidante
			const challengerName = challenge.user ? (challenge.user.nickname || `Utente ${challenge.user.id}`) : `Utente ${challenge.user_id}`;
			const challengerText = this.add.text(
				centerX - 150,
				y,
				challengerName,
				{...setup.styles.gameOver.greetingStyle, fontSize: 20, fill: '#FFFFFF'}
			).setOrigin(0.5);

			// Punteggio da battere (se disponibile)
			let scoreText = '';
			if (challenge.round && challenge.round.score !== undefined) {
				scoreText = `Punteggio: ${challenge.round.score}`;
			}
			const scoreLabel = this.add.text(
				centerX,
				y,
				scoreText,
				{...setup.styles.gameOver.greetingStyle, fontSize: 18, fill: '#FFFF00'}
			).setOrigin(0.5);

			// Bottone accetta
			const acceptButton = new Button(
				this,
				centerX + 100,
				y - 15,
				'green-button',
				1.0,
				'Accetta',
				false
			);

			acceptButton.on('pointerup', () => {
				this.acceptChallenge(challenge.id);
			});

			// Bottone rifiuta
			const rejectButton = new Button(
				this,
				centerX + 100,
				y + 15,
				'red-button',
				1.0,
				'Rifiuta',
				false
			);

			rejectButton.on('pointerup', () => {
				this.rejectChallenge(challenge.id);
			});
		});
	}

	acceptChallenge(inviteId) {
		axios.post(`/api/invites/${inviteId}/accept`)
			.then((response) => {
				console.log('Sfida accettata:', response.data);
				
				// Se il risultato è immediato (amico ha già giocato)
				if (response.data.immediate_result) {
					this.scene.start('ChallengeResult', { 
						invite: response.data.invite, 
						result: response.data.result 
					});
				} else {
					// Nuovo round creato - avvia il gioco con il round restituito
					if (response.data.round) {
						// Il round è già stato creato dall'API, possiamo usarlo direttamente
						// Passa i dati del round alla scena Boot per inizializzare il gioco
						this.scene.start('Boot', { 
							round: response.data.round,
							invite_id: inviteId 
						});
					} else {
						// Fallback: usa invite_id per creare il round in StartAction
						this.scene.start('Boot', { invite_id: inviteId });
					}
				}
			})
			.catch((error) => {
				console.error('Errore accettazione sfida:', error);
				const errorMsg = error.response && error.response.data && error.response.data.message 
					? error.response.data.message 
					: 'Errore nell\'accettazione della sfida';
				this.showError(errorMsg);
			});
	}

	rejectChallenge(inviteId) {
		axios.post(`/api/invites/${inviteId}/reject`)
			.then((response) => {
				console.log('Sfida rifiutata:', response.data);
				// Ricarica la lista
				this.scene.restart();
			})
			.catch((error) => {
				console.error('Errore rifiuto sfida:', error);
				this.showError('Errore nel rifiuto della sfida');
			});
	}

	showNoChallenges() {
		this.add.text(
			this.sys.game.config.width / 2,
			this.sys.game.config.height / 2,
			'Nessuna sfida in attesa',
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);
	}

	showError(message) {
		if (this.loadingText) {
			this.loadingText.destroy();
		}
		this.loadingText = this.add.text(
			this.sys.game.config.width / 2,
			this.sys.game.config.height / 2,
			message,
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FF0000'}
		).setOrigin(0.5);
	}
}
